import React from 'react';
import Grid from '@material-ui/core/Grid';

function GridCenterItem({ children, noControl }) {
  return (
    <Grid item container xs={12} alignItems="center" justify="center">
      {noControl ? (
        <Grid item container xs={12}>
          {children}
        </Grid>
      ) : (
        <Grid item container xs={12} sm={8} md={6} lg={5}>
          {children}
        </Grid>
      )}
    </Grid>
  );
}

export default GridCenterItem;
